export function handleSelectTriggerKeyDown({
  event,
  open,
  selectedIndex,
  highlightedIndex,
  options,
  setOpen,
  setHighlightedIndex,
  moveHighlight,
  commitChange,
}) {
  const key = event?.key;

  if (key === 'ArrowDown') {
    event.preventDefault();
    if (!open) {
      setOpen(true);
      setHighlightedIndex(Math.max(0, selectedIndex));
    } else {
      moveHighlight(1);
    }
    return;
  }

  if (key === 'ArrowUp') {
    event.preventDefault();
    if (!open) {
      setOpen(true);
      setHighlightedIndex(Math.max(0, selectedIndex));
    } else {
      moveHighlight(-1);
    }
    return;
  }

  if (key === 'Enter' || key === ' ') {
    event.preventDefault();
    if (!open) {
      setOpen(true);
      setHighlightedIndex(Math.max(0, selectedIndex));
      return;
    }

    const opt = options?.[highlightedIndex];
    if (opt && !opt.disabled) commitChange(opt.value);
    return;
  }

  if (key === 'Tab') {
    setOpen(false);
  }
}
